import { render, staticRenderFns } from "./CustomFieldListing.vue?vue&type=template&id=80ac3e82"
import script from "./CustomFieldListing.vue?vue&type=script&lang=js"
export * from "./CustomFieldListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports